// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federnfabrik-dietz-gmbh-unter-den-nominierten/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federnfabrikDietzGmbhUnterDenNominiertenDE: PageEntry = {
  id: "post.federnfabrik-dietz-gmbh-unter-den-nominierten",
  locale: "de",
  slug: "federnfabrik-dietz-gmbh-unter-den-nominierten",
  seo: {
    title: "Federnfabrik Dietz GmbH unter den Nominierten | Dietz GmbH",
    description: "Federnfabrik Dietz GmbH unter den Nominierten",
  },
  type: "post",
  h1: "Federnfabrik Dietz GmbH unter den Nominierten",
  blocks: [
    { kind: "heading", level: 2, text: "Federnfabrik Dietz GmbH unter den Nominierten" },
    { kind: "heading", level: 2, text: "Shortlist des MX Award 2014 steht fest" },
    { kind: "paragraph", text: "Nach Auswertung des am 06. April abgeschlossenen Self Assessment Audits (SAA) steht nun die Shortlist des MX Award 2014 fest." },
    { kind: "paragraph", text: "13 Unternehmen, darunter drei Anwärter für den Sonderpreis für kleine und mittlere Unternehmen (KMU), haben sich qualifiziert und werden in den Kalenderwochen 22 bis 26 vom erfahrenen MX Assessorenteam unter Leitung der Technischen Universität Berlin im Rahmen der Business Reviews (BR) besucht und bewertet." },
    { kind: "paragraph", text: "Auf der Sitzung der MX Jury am 11. Juli werden auf Basis der Ergebnisse des SAA und der BRs die Gewinner des MX Award 2014 gekürt. Die feierliche Preisverleihung findet am 14. November im Axel-Springer-Haus in Berlin statt." },
    { kind: "paragraph", text: "Quelle: MX Award 2014" }
  ],
};
